import { Bulletin } from "entities/bulletin/types";
import { Dispatch, SetStateAction } from "react";
import { DrawerHookResult } from "shared/hooks/useDrawerState";

export type BulletinBoardPageType = {
  data: Bulletin[];
  isLoading: boolean;
  bulletinBoardDetailsDrawer: DrawerHookResult<string>;
  openDeleteModal: boolean;
  handleDeleteModal: () => void;
  selectedBulletin: Bulletin | null;
  setSelectedBulletin: Dispatch<SetStateAction<Bulletin | null>>;
};

export enum ManagedTranslations {
  Title = "Title",
  Description = "Description",
}
